import { NativeStackScreenProps } from "@react-navigation/native-stack";

import { FulfillmentDispatchType } from "../types";

export const deliveryFulfillmentsRoutes = {
  deliveryModeList: "Envíos",
  automaticFulfillments: "Envíos automáticos",
  pickupLocation: "Dirección de recogida",
  map: "Mapa",
  automaticFulfillment: "Envío automático",
} as const;

export type DeliveryFulfillmentsStackParamList = {
  [deliveryFulfillmentsRoutes.deliveryModeList]: undefined;
  [deliveryFulfillmentsRoutes.automaticFulfillments]: undefined;
  [deliveryFulfillmentsRoutes.pickupLocation]: undefined;
  [deliveryFulfillmentsRoutes.map]: undefined;
  [deliveryFulfillmentsRoutes.automaticFulfillment]: {
    type: FulfillmentDispatchType;
  };
};

export type DeliveryFulfillmentsRoute =
  keyof DeliveryFulfillmentsStackParamList;

export type DeliveryFulfillmentsScreenProps<
  T extends DeliveryFulfillmentsRoute = DeliveryFulfillmentsRoute
> = NativeStackScreenProps<DeliveryFulfillmentsStackParamList, T>;
